export const baseEmpty = {
  emptyMessage: '暂无数据'
}
